export const firstOrDefault = (source, predicate) => {
    if (predicate) {
        return firstOrDefault2(source, predicate);
    }
    else {
        return firstOrDefault1(source);
    }
};
const firstOrDefault1 = (source) => {
    const first = source[Symbol.iterator]().next();
    return first.value ?? null;
};
const firstOrDefault2 = (source, predicate) => {
    for (const value of source) {
        if (predicate(value) === true) {
            return value;
        }
    }
    return null;
};
